import { Button } from '@/components';
import FileUploadTemplate from '@/components/common/FileUpload/FileUploadTemplate';
import { useBiCustomer } from '@/context/biCustomerContext/BiCustomerContextProvider';
import React, { useEffect, useState } from 'react';

const UploadFile = () => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const {
    uploadCustomerFile,
    confirmData,
    setConfirmData,
    confirmBiCustomersApi,
  } = useBiCustomer();
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectAll, setSelectAll] = useState(false);

  const handleFilesSelected = (files) => {
    if (files.length !== 1) {
      alert('Please upload exactly one file.');
      return;
    }
    setSelectedFiles(files);
  };

  useEffect(() => {
    setConfirmData([]);
  }, []);

  useEffect(() => {
    if (confirmData.length > 0) {
      setShowModal(true);
    }
    return () => {
      setShowModal(false);
    };
  }, [confirmData]);

  const closeModal = () => {
    setShowModal(false);
  };

  const handleUpload = async (files) => {
    if (files.length === 1) {
      await uploadCustomerFile(files[0]);
      setSelectedFiles([]); // Clear selected files after successful upload
    } else {
      alert('Please select a file to upload.');
    }
  };

  const handleCheckboxChange = (item) => {
    setData((prevData) => {
      if (prevData.some((dataItem) => dataItem.account === item.account)) {
        return prevData.filter((dataItem) => dataItem.account !== item.account);
      } else {
        return [...prevData, item];
      }
    });
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setData([]);
    } else {
      setData(confirmData);
    }
    setSelectAll(!selectAll);
  };

  const handleSubmit = () => {
    // Handle the submission of selected data
    confirmBiCustomersApi(data, closeModal);
  };

  return (
    <div>
      <div>
        <h2 className="text-2xl font-semibold text-gray-800 mb-4"></h2>
        <p className="text-gray-500 mb-6 text-center">
          Please upload a CSV file containing product data.
        </p>

        <FileUploadTemplate
          acceptedFileTypes={['.csv']}
          onFilesSelected={handleFilesSelected}
          multiple={false}
          onUpload={handleUpload}
          maxFiles={1}
        />
      </div>
      <div className="overflow-x-auto rounded-lg bg-gray-50 shadow-sm">
        <table className="min-w-full divide-y divide-gray-200 text-sm text-gray-700">
          <thead className="bg-gray-100">
            <tr>
              <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                Account{' '}
              </th>
              <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                Account Name
              </th>
              <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                {' '}
                Rep
              </th>
              <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                Marketing
              </th>
              <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                {' '}
                Industry Sub
              </th>
              <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                {' '}
                Business Code
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {/* Sample Row */}
            <tr>
              <td className="py-2 px-4 text-center">XY0121</td>
              <td className="py-2 px-4 text-center">ABC EFG</td>
              <td className="py-2 px-4 text-center">23</td>
              <td className="py-2 px-4 text-center">XYZ</td>
              <td className="py-2 px-4 text-center">IT</td>
              <td className="py-2 px-4 text-center">A200212A</td>
            </tr>
            {/* Additional rows can be added here */}
          </tbody>
        </table>
      </div>

      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
          <div className="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all  max-h-screen min-h-3/4">
            <div className="p-4 border-b">
              <h3 className="text-lg font-medium text-gray-900">
                Confirm Data
              </h3>
            </div>
            <div className="overflow-x-auto rounded-lg bg-gray-50 shadow-sm h-full">
              <div className="p-4">
                <button
                  className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                  onClick={handleSelectAll}
                >
                  {selectAll ? 'Deselect All' : 'Select All'}
                </button>
              </div>
              <table className="min-w-full divide-y divide-gray-200 text-sm text-gray-700">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                      Select
                    </th>
                    <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                      #
                    </th>
                    <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                      Account
                    </th>
                    <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                      Name
                    </th>
                    <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                      New Rep
                    </th>
                    <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                      Old Rep
                    </th>
                    <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                      Marketing
                    </th>
                    <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                      Industry Sub
                    </th>
                    <th className="py-3 px-4 font-semibold text-gray-600 text-center">
                      Business Code
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {confirmData.map((item, index) => (
                    <tr key={item.account}>
                      <td className="py-2 px-4 text-center">
                        <input
                          type="checkbox"
                          checked={data.some(
                            (dataItem) => dataItem.account === item.account,
                          )}
                          onChange={() => handleCheckboxChange(item)}
                        />
                      </td>
                      <td className="py-2 px-4 text-center">{index + 1}</td>
                      <td className="py-2 px-4 text-center">{item.account}</td>
                      <td className="py-2 px-4 text-center">
                        {item.accountName}
                      </td>
                      <td className="py-2 px-4 text-center">{item.newRep}</td>
                      <td className="py-2 px-4 text-center">{item.oldRep}</td>
                      <td className="py-2 px-4 text-center">
                        {item.marketing}
                      </td>
                      <td className="py-2 px-4 text-center">
                        {item.industrySub}
                      </td>
                      <td className="py-2 px-4 text-center">
                        {item.businessCode}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="my-4 flex justify-center text-center">
                <Button
                  className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded"
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UploadFile;
